"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[5997],{

/***/ 65997:
/***/ ((module) => {

module.exports = JSON.parse('{"cantConnectToMessageServiceText":"Failed to establish contact with the messaging service","cantConnectToMessageServiceHead":"Messaging service","userWithNoTeamLoggedIn":"A user who has not been assigned to a team just logged in","youHaveNewTodoItem":"You have received a new To-Do item.","youHaveNewTodoItemFrom":"It was created by {name}.","openTodoItem":"Open To-Do item","todoItemHasChangedHead":"One of your to-do items has been changed","todoItemHasChangedText":"{name} has changed something in one of your To-Do items","companyHasConnectedWithPackage":"A company has been associated with packaging","companyHasConnectedWithPackageText":"{clientName} is now a company with packaging"}');

/***/ })

}]);